import { EdiNotify } from "../EdiNotify";
import { Button, Checkbox, DataHeader, DataSource, Label, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutGenericProfile extends Layout {
    buttonAckTemplateSetup: Button;
    buttonFaMasterBatch: Button;
    buttonFilenameCustomize: Button;
    buttonOpenClassic: Button;
    buttonSetup: Button;
    buttonTransactionCustomize: Button;
    checkboxFuncUseMBatch: Checkbox;
    checkboxSendFuncAck: Checkbox;
    dataheaderGenericProfile: DataHeader;
    labelDirectionOutbound: Label;
    labelFuncMasterBatch: Label;
    labelNextBatchNumber: Label;
    layoutNotifications: EdiNotify;
    panelFuncBatch: Panel;
    panelHeader: Panel;
    panelNotes: Panel;
    panelOutboundFuncAck: Panel;
    sourceEdiNotify: DataSource;
    sourceEdiProfile: DataSource;
    sourceEdiTemplate: DataSource;
    tabFunctionalAcknowledgement: Tab;
    tabNotifications: Tab;
    tabPartnerNotes: Tab;
    tabsetGenericProfile: Tabset;
    textboxAckXmitMethod: Textbox;
    textboxAltPartnerId: Textbox;
    textboxCommId: Textbox;
    textboxDirection: Textbox;
    textboxFuncAckFilename: Textbox;
    textboxFuncAckSt02Frmt: Textbox;
    textboxFuncAckTid: Textbox;
    textboxFuncAltpartnerId: Textbox;
    textboxFuncCommId: Textbox;
    textboxFuncNextBatch: Textbox;
    textboxFuncPartnerId: Textbox;
    textboxFuncVersion: Textbox;
    textboxNextBatch: Textbox;
    textboxNotes: Textbox;
    textboxPartnerId: Textbox;
    textboxPartnerName: Textbox;
    textboxProcessPriority: Textbox;
    textboxSendToCompany: Textbox;
    textboxTemplateId: Textbox;
    textboxTransactionSet: Textbox;
    textboxTransactionTyoe: Textbox;
    textboxVersion: Textbox;
}
